import './Butter.css';
import butter from "../../assets/images/butter.png";
import React from "react";

function Butter() {

    return (
         <div className="">
            <div className="butterBody">
                <img src={butter} alt="" className="butterImage" />
            </div>
           <a className="backToHomeTerms" href='/' rel="noreferrer"> back to home</a>
        </div>
    )
}

export default Butter;